<se-po-household-review *ngIf="storeLoaded"
  [child]="child"
  [parent]="parent"
  [guardianInvites]="guardianInvites"
  (cancelInvite)="onCancelInvite($event)"
  (continue)="onContinue()"
  (addAnother)="onAddAnother()">
</se-po-household-review>
